import { useSearchParams } from 'react-router-dom'

export type ContentsTab = 'training' | 'material'

export default function useContentsPage() {
  const [searchParams, setSearchParams] = useSearchParams({
    tab: 'training',
  })

  const selectedTab = searchParams.get('tab') as ContentsTab

  const setSelectedTab = (tab: ContentsTab) => {
    setSearchParams((prev) => {
      prev.set('tab', tab)
      return prev
    })
  }

  return {
    selectedTab,
    setSelectedTab,
  }
}
